import { createContext, useContext } from "react";

import { PatientMatchHelper } from "./PatientMatchHelper.ts";

export const PatientMatchContext = createContext<PatientMatchHelper>(
  {} as PatientMatchHelper
);

export const usePatientMatchContext = () => useContext(PatientMatchContext);
